module.exports = __webpack_public_path__ + "static/media/as-logo.37ade68b.png";